'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 *
 */
var ExportEntry = /*#__PURE__*/function (_React$Component) {
  _inherits(ExportEntry, _React$Component);

  function ExportEntry(props) {
    _classCallCheck(this, ExportEntry);

    return _possibleConstructorReturn(this, (ExportEntry.__proto__ || Object.getPrototypeOf(ExportEntry)).call(this, props));
  }
  /**
   *
   * @returns {*}
   */


  _createClass(ExportEntry, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x grid-padding-x space-2"
      }, !this.props.confirmExport && /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12 medium-10 large-9 xlarge-8"
      }, /*#__PURE__*/_react.default.createElement("h2", null, this.props.title), /*#__PURE__*/_react.default.createElement("p", null, this.props.description), /*#__PURE__*/_react.default.createElement("a", {
        href: this.props.downloadUrl,
        target: '_blank',
        rel: 'noopener',
        title: this.props.linkTitle
      }, this.props.linkText)));
    }
  }]);

  return ExportEntry;
}(_react.default.Component);

ExportEntry.propTypes = {
  title: _propTypes.default.string.isRequired,
  description: _propTypes.default.string,
  linkTitle: _propTypes.default.string,
  linkText: _propTypes.default.string.isRequired,
  downloadUrl: _propTypes.default.string.isRequired,
  confirmExport: _propTypes.default.bool
};
var _default = ExportEntry;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/export-container/lib/export-entry.js
// module id = 758
// module chunks = 0